import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface LogoMarkProps {
    className?: string
}

interface LogoProps {
    className?: string
    inverted?: boolean
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 32 32' aria-hidden='true' className={cn('size-10 shrink-0', className)}>
            <rect width='32' height='32' rx='9' className='fill-aqua' />
            <path d='M16 6C13.5 9.5 9.5 14.2 9.5 18.5A6.5 6.5 0 0 0 22.5 18.5C22.5 14.2 18.5 9.5 16 6Z' className='fill-ink' />
            <path d='M12.9 19.1A3.4 3.4 0 0 0 15.6 22.2' fill='none' stroke='white' strokeWidth='1.7' strokeLinecap='round' />
            <path d='M24.5 4.8L25.3 6.7L27.2 7.5L25.3 8.3L24.5 10.2L23.7 8.3L21.8 7.5L23.7 6.7Z' fill='white' />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ className, inverted = false }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <LogoMark />

            <span className='flex flex-col'>
                <span className={cn('font-heading text-[1.6rem] font-bold uppercase leading-[0.9] tracking-wide', inverted ? 'text-white' : 'text-ink')}>
                    {siteConfig.name}
                </span>

                <span className={cn('mt-1 text-[0.62rem] font-bold uppercase leading-none tracking-[0.24em]', inverted ? 'text-white/55' : 'text-muted-foreground')}>
                    Car wash and valeting
                </span>
            </span>
        </span>
    )
}
